export const addToDataLayer = (eventName) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
  });
};

export const addEnhancedToDataLayer = (userEmail) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "Form Submission Get An Offer",
    user_data: {
      email: userEmail,
    },
  });
  window.dataLayer.push({
    event: "gtm.formSubmit",
    user_data: {
      email: userEmail,
    },
  });
  window.dataLayer.push({
    event: "form_submit",
    user_data: {
      email: userEmail,
    },
  });
};
